module.exports = __webpack_public_path__ + "img/icon-channel-celebrity.187dc150.png";